import { render, staticRenderFns } from "./PermissionsGroupsList.vue?vue&type=template&id=ebdff442&"
import script from "./PermissionsGroupsList.vue?vue&type=script&lang=js&"
export * from "./PermissionsGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports